(function () {
    'use strict';

    angular
        .module('app')
        .controller('registerController',
        ['registerService', 'accountsService', 'vcRecaptchaService', '$location', registerController]);

    function registerController(registerService, accountsService, vcRecaptchaService, $location) {
        /* jshint validthis:true */
        var vm = this;
        vm.model = {};
        vm.model.key = '6LcNI_USAAAAAKsNxQy87SYgrZFAmiJuuQyvHcpV';

        accountsService.getAuthenticatedAccount()
            .then(function (response) {
                vm.model.isAdmin = (response.accountType === AccountType.Admin ||
                    response.accountType === AccountType.SuperAdmin);
                vm.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);

                if(!vm.model.isAdmin && !vm.model.isSuperAdmin)
                    $location.url('/dashboard');

            });
        vm.NavigateToApproval = function() {
            $location.url('/registrations');
        };
        vm.submit = function () {

            vm.submitted = true;
            if (!vm.createAccountForm.$valid) {

                vm.model.working = false;

                vm.model.error = "Please check all fields are filled in correctly.";
                vm.model.complete = true;
                vm.model.success = false;

                return;
            }

            vm.model.working = true;

            var register = {
                firstName: vm.model.firstName,
                lastName: vm.model.lastName,
                email: vm.model.email,
                companyName: vm.model.companyName,
                address1: vm.model.address1,
                address2: vm.model.address2,
                address3: vm.model.address3,
                postcode: vm.model.postcode,
                phoneNumber: vm.model.phoneNumber,
                website: vm.model.website,
                isCrmIntegrated: vm.model.isCrmIntegrated,
                crmName: vm.model.crmName

        };

            vm.model.complete = false;

            registerService.addRegistration(register)
                .then(function() {
                        vm.model.complete = true;
                        vm.model.success = true;
                    },
                    function(response) {
                        vm.model.working = false;

                        vm.model.error = response.errors[0].message;
                        vm.model.complete = true;
                        vm.model.success = false;

                        vcRecaptchaService.reload();
                    });
        };

      
    }

})();